export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';


export const GET_PERIOD_DEFINITIONS_SUCCESS = 'GET_PERIOD_DEFINITIONS_SUCCESS';
export const GET_PERIOD_DEFINITIONS_FAIL = 'GET_PERIOD_DEFINITIONS_FAIL';
export const GET_PERIOD_DEFINITION_SUCCESS = 'GET_PERIOD_DEFINITION_SUCCESS';
export const GET_PERIOD_DEFINITION_FAIL = 'GET_PERIOD_DEFINITION_FAIL';
export const CREATE_PERIOD_DEFINITION_SUCCESS = 'CREATE_PERIOD_DEFINITION_SUCCESS';
export const CREATE_PERIOD_DEFINITION_FAIL = 'CREATE_PERIOD_DEFINITION_FAIL';
export const UPDATE_PERIOD_DEFINITION_SUCCESS = 'UPDATE_PERIOD_DEFINITION_SUCCESS';
export const UPDATE_PERIOD_DEFINITION_FAIL = 'UPDATE_PERIOD_DEFINITION_FAIL';
export const DELETE_PERIOD_DEFINITION_SUCCESS = 'DELETE_PERIOD_DEFINITION_SUCCESS';
export const DELETE_PERIOD_DEFINITION_FAIL = 'DELETE_PERIOD_DEFINITION_FAIL';

export const GENERATE_PERIODS_SUCCESS = 'GENERATE_PERIODS_SUCCESS';
export const GENERATE_PERIODS_FAIL = 'GENERATE_PERIODS_FAIL';
export const GENERATE_PERIODS_BY_NAME_YEAR_SUCCESS = 'GENERATE_PERIODS_BY_NAME_YEAR_SUCCESS';
export const GENERATE_PERIODS_BY_NAME_YEAR_FAIL = 'GENERATE_PERIODS_BY_NAME_YEAR_FAIL';

